//Administrator
export const MENU: any = [
    {
      title: 'ADMIN MENU',
      groupTitle: true
    },
    {
      title: 'Dashboards',
      icon: {
        class: 'fa fa-pie-chart',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/dashboard'
    },
    {
      title: 'Monitor',
      icon: {
        class: 'fa fa-bar-chart',
        bg: '#2b303b',
        color: '#fff'
      },
  
      badge: {
        text: '12',
        color: '#fff',
        bg: '#43A047'
      },
      sub: [
        {
          title: 'Material stock status',
          routing: '/default-layout/monitor-two'
        },
        {
          title: 'Material ordering status',
          routing: '/default-layout/monitor-four'
        },
        {
          title: 'Material Dead Stock',
          routing: '/default-layout/monitor-six'
        }
      ]
    },
    {
      title: 'Material Reports',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '7',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
        {
          title:'Material Stock Control Report',
          routing:'/default-layout/rm-report/report-rm-stock'
        },
      
        {
          title:'Material Stock list Report',
          routing:'/default-layout/rm-report/information-part-delay-delivery-plating'
        },
        {
          title:'Materail Dead Stock Report',
          routing:'/default-layout/rm-report/dead-stock-rm-pt-report'
        }
      ]
    },
    {
      title: 'BOM',
      icon: {
        class: 'fa fa-random',
        bg: '#2b303b',
        color: '#fff'
      },
     
      routing: '/default-layout/bom'
    },
    {
      title: 'Warehouse',
      icon: {
        class: 'fa fa-stack-overflow',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/warehouse'
  
    },
    {
      title: 'Material',
      icon: {
        class: 'fa fa-cubes',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/material'
  
    },
    {
      title: 'Product',
      icon: {
        class: 'fa fa-product-hunt',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/product'
  
    },
    {
      title: 'Supllier',
      icon: {
        class: 'fa fa-bars',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/supplier'
  
    },
    {
      title: 'Customer',
      icon: {
        class: 'fa fa-address-book-o',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/customer'
    },
    {
      title: 'Stock cards',
      icon: {
        class: 'fa fa-print',
        bg: '#2b303b',
        color: '#fff'
      },
      badge: {
        text: '4',
        color: '#fff',
        bg: '#43A047'
      },
      sub: [
        {
          title: 'Material',
          routing: '/default-layout/tracking-print/rm'
        }
      ]
  
    },
    {
      title: 'Forcast stock control',
      icon: {
        class: 'fa fa-building',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/stock-planning'
  
    },
    {
        title: 'Setting',
        icon: {
          class: 'fa fa-cog',
          bg: '#2b303b',
          color: '#fff'
        },
        badge: {
          text: '8',
          color: '#fff',
          bg: '#43A047'
        },
        sub: [
          {
            title: 'Machine',
            routing: '/default-layout/machine'
          },
         
          {
            title: 'Process',
            routing: '/default-layout/process'
          },
          {
            title: 'Grouping & Sortting process',
            routing: '/default-layout/plan-process'
          },
          {
            title: 'Production line',
            routing: '/default-layout/production-line'
          },
          {
            title: 'Operator & Skill',
            routing:'/default-layout/operator-setting'
          },
          {
            title: 'Operator permission',
            routing:'/default-layout/operator-permission'
          }
        ]
    
      },
    {
      title: 'System Users',
      icon: {
        class: 'fa fa-odnoklassniki',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/user'
    }
  
  ];
  
  //CEO
  export const MENU1: any = [
    {
      title: 'CEO MENU',
      groupTitle: true
    },
    {
      title: 'Dashboards',
      icon: {
        class: 'fa fa-pie-chart',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/dashboard'
    },
    {
      title: 'Monitor',
      icon: {
        class: 'fa fa-bar-chart',
        bg: '#2b303b',
        color: '#fff'
      },
  
      badge: {
        text: '11',
        color: '#fff',
        bg: '#43A047'
      },
      sub: [
        {
          title: 'Finished good stock status',
          routing: '/default-layout/monitor-one'
        },
        {
          title: 'Material stock status',
          routing: '/default-layout/monitor-two'
        },
        {
          title: 'Inventory comparison',
          routing: '/default-layout/monitor-three'
        },
        {
          title: 'Material ordering status',
          routing: '/default-layout/monitor-four'
        },
        {
          title: 'FG Delivery ordering status',
          routing: '/default-layout/monitor-five'
        },
        {
          title: 'Material Dead Stock',
          routing: '/default-layout/monitor-six'
        },
        {
          title: 'Plating Dead Stock',
          routing: '/default-layout/monitor-seven'
        },
        {
          title: 'Finished Good Dead Stock',
          routing: '/default-layout/monitor-eight'
        },
        {
          title: 'Loss time',
          routing: '/default-layout/pd-monitor-7'
        },
        {
          title: 'Monthly Order/Actual',
          routing: '/default-layout/pd-monitor-5'
        },
        {
          title: 'NG Monitor',
          routing: '/default-layout/pd-monitor-6'
        }
      ]
    }
  
  ];
  
  //PC1
  export const MENU2: any = [
    {
      title: 'PC1 MENU',
      groupTitle: true
    },
    {
      title: 'FG reports',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '10',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
  
        {
          title:'Daily Report',
          routing:'/default-layout/fg-report/report-daily'
        },
        {
          title: 'Monthly Report',
          routing: '/default-layout/fg-report/report-monthly'
        },
        {
          title:'Finished Good Stock list Report',
          routing:'/default-layout/fg-report/fg-in-out-stock-status-list'
        },
        {
          title:'Finished Good Dead Stock Report',
          routing:'/default-layout/fg-report/dead-stock-fg-report'
        },
        {
          title:'Record Delivery Time Sheet',
          routing:'/default-layout/fg-report/supplier-delivery-log-book'
        },
        {
          title:'BOM Material Part Lists',
          routing:'/default-layout/fg-report/bom-material-part-lists'
        }
        
      ]
    },
    {
      title: 'Forcast stock control',
      icon: {
        class: 'fa fa-building',
        bg: '#2b303b',
        color: '#fff'
      },
      routing: '/default-layout/stock-planning'
  
    },
    {
      title: 'Monthly plan',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '3',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
        {
          title:'Plating monthly plan',
          routing:'/default-layout/pd-report/platting-monthly-plan'
        },
        {
          title:'Production monthly plan',
          routing:'/default-layout/pd-report/production-monthly-plan'
        },
        {
          title:'Collect plating monthly plan',
          routing:'/default-layout/pd-report/collect-monthly-plan'
        }
      ]
    },
    {
      title: 'Material Reports',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '7',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
        {
          title:'Material daily report',
          routing:'/default-layout/rm-report/rm-daily-report'
          
        },
        {
          title:'Material monthly report',
          routing:'/default-layout/rm-report/rm-monthly-report'
          
        },
        {
          title:'Material Stock Control Report',
          routing:'/default-layout/rm-report/report-rm-stock'
        },
      
        {
          title:'Material Stock list Report',
          routing:'/default-layout/rm-report/information-part-delay-delivery-plating'
        },
        {
          title:'Materail Dead Stock Report',
          routing:'/default-layout/rm-report/dead-stock-rm-pt-report'
        },
        {
          title:'Stock Qty Summary',
          routing:'/default-layout/rm-report/stock-qty-summary'
        }
      ]
    }
  ];
  
  //PC2
  export const MENU3: any = [
    {
      title: 'PC2 MENU',
      groupTitle: true
    },
    {
      title: 'Material Reports',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '8',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
        {
          title:'Material daily report',
          routing:'/default-layout/rm-report/rm-daily-report'
          
        },
        {
          title:'Material monthly report',
          routing:'/default-layout/rm-report/rm-monthly-report'
          
        },
        {
          title:'Material Stock Control Report',
          routing:'/default-layout/rm-report/report-rm-stock'
        },
      
        {
          title:'Material Stock list Report',
          routing:'/default-layout/rm-report/information-part-delay-delivery-plating'
        },
        {
          title:'Materail Dead Stock Report',
          routing:'/default-layout/rm-report/dead-stock-rm-pt-report'
        },
        {
          title:'Stock Qty Summary',
          routing:'/default-layout/rm-report/stock-qty-summary'
        },
        {
          title:'Plating monthly plan',
          routing:'/default-layout/pd-report/platting-monthly-plan'
        },
        {
          title:'Collect plating monthly plan',
          routing:'/default-layout/pd-report/collect-monthly-plan'
        }
      ]
    }
  ];
  
  //PU
  export const MENU4: any = [
    {
      title: 'RPU MENU',
      groupTitle: true
    },
    {
      title: 'Material Reports',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '5',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
        {
          title:'Material Stock Control Report',
          routing:'/default-layout/rm-report/report-rm-stock'
        },
      
        {
          title:'Material Stock list Report',
          routing:'/default-layout/rm-report/information-part-delay-delivery-plating'
        },
        {
          title:'Plating monthly plan',
          routing:'/default-layout/pd-report/platting-monthly-plan'
        },
        {
          title:'Production monthly plan',
          routing:'/default-layout/pd-report/production-monthly-plan'
        },
        {
          title:'Collect plating monthly plan',
          routing:'/default-layout/pd-report/collect-monthly-plan'
        }
      ]
    },
  ];
  //QC
  export const MENU5: any = [
  
    {
      title: 'QC MENU',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '6',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
        {
          title:'Control Chart Report',
          routing:'/default-layout/pd-report/qc-report-1'
        },
        {
          title:'Daily Scrap Record',
          routing:'/default-layout/pd-report/daily-scrap-record'
        }
  
      ]
    }
  ];
  
  // PD
  export const MENU6: any = [
  
    {
      title: 'PD & QC Reports',
      icon: {
        class: 'fa fa-clipboard',
        bg: '#2b303b',
        color: '#fff'
      },
      badge:{
        text: '6',
        color: '#fff',
        bg: '#43A047'
      },
      sub:[
        {
          title:'Plating monthly plan',
          routing:'/default-layout/pd-report/platting-monthly-plan'
        },
        {
          title:'Production monthly plan',
          routing:'/default-layout/pd-report/production-monthly-plan'
        },
        {
          title:'Collect plating monthly plan',
          routing:'/default-layout/pd-report/collect-monthly-plan'
        },
        {
          title:'QC1 Report',
          routing:'/default-layout/pd-report/pd-report-1'
        },
        {
          title:'Control chart',
          routing:'/default-layout/pd-report/qc-report-1'
        },
        {
          title:'Daily Scrap Record',
          routing:'/default-layout/pd-report/daily-scrap-record'
        },
        {
          title:'Daily Production Report',
          routing:'/default-layout/pd-report/daily-production-report'
        },
        {
          title:'Daily Production record',
          routing:'/default-layout/pd-report/pd-report-3'
        },
        {
          title:'Daily Production list',
          routing:'/default-layout/pd-report/pd-report-2'
        }
  
      ]
    },
    {
      title: 'Setting',
      icon: {
        class: 'fa fa-cog',
        bg: '#2b303b',
        color: '#fff'
      },
      badge: {
        text: '8',
        color: '#fff',
        bg: '#43A047'
      },
      sub: [
       
        {
          title: 'Operator & Skill',
          routing:'/default-layout/operator-setting'
        },
        {
          title: 'Control check sheet',
          routing:'/default-layout/check-sheet-setting'
        },
        {
          title: 'Control Chart',
          routing: '/default-layout/control-chart-setting'
        },
        {
          title: 'Event & interrupt',
          routing: '/default-layout/event-setting'
        },
        {
          title: 'Specification',
          routing: '/default-layout/product-standard'
        }
      ]
  
    }
  
  ];


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/settings/dip-menu.ts